// extracted by mini-css-extract-plugin
export var chevron = "_i2-2";
export var dropdownItems = "_i2-0";
export var item = "_i2-1";